import { Box, Grid} from "@mui/material"
import { Generate } from "./Generate"
import { ReconcileRead } from "../../../global/API"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { BackDrop } from "../../../../../core/global/BackDrop"
import moment from "moment"
import { Body } from "./Body"
import { MessageModal } from "../../../../../core/global/modal/MessageModal"
import { NoDataFound } from "../../../empty/Index"

export const Index = () =>{
    const {session_state, reconciliation_state, tool_state, setup_state} = useContext(ToolContext)
    const {navSession} = session_state
    const { branchUserData } = setup_state;
    const {__SESSION} = tool_state
    const {loader, isToReconcile, toReconcileList, reconciledList, infiniteState, snackBarLoader, form} = reconciliation_state
    const role = __SESSION.data.uaccess[0].role_name
    const today = moment(new Date()).format('YYYY-MM-DD')

    const branchEodRead = async () => {
        const qsp = {
            date: form.data.from || today,
            date_from: isToReconcile.data && role === "Regular User" ? "" : form.data.from || today,
            date_to: isToReconcile.data && role === "Regular User" ? "" : form.data.to || today,
            company_branch_id: form.data.branch_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            limit: infiniteState.data.limit,
            offset: infiniteState.data.offset,
            filter:isToReconcile.data && role === 'Regular User' ? 'to-reconcile': 'reconciled'
        }
        try {
            navSession.set((prev) => ({...prev, isShow:true}))
            const res = await ReconcileRead(qsp)
            if (res.msg === "Not yet submitted") {
                role === "Regular User" && loader.set(prev => ({ ...prev, isShowWarningModal: true, warningText: 'Complete EoD Sales Report First!', warningSubText: 'Ensure that the EoD sales report is submitted before proceeding with reconciliation.' }));
            } else if (res.msg === "Already Reconciled") {
                role === "Regular User" && loader.set(p => ({ ...p, isShowWarningModal: true, warningText: 'POS Report Already Submitted!', warningSubText: 'You can check the submitted report in the reconciled tab.' }));
                toReconcileList.set([]);
            } else {
                if (res.bs_data.length > 0){
                    infiniteState.set((prev) => ({...prev,  offset: prev.offset + infiniteState.data.limit}))
                    isToReconcile.data ? toReconcileList.set((prev) => [...prev, ...res.bs_data]) : reconciledList.set((prev) => [...prev, ...res.bs_data]);
                }else{
                    infiniteState.set((prev) => ({...prev,  offset: 0}))
                    loader.set(prev => ({ ...prev, isShowData: true}));
                    navSession.set((prev) => ({...prev, isShow:false}))
                }
            }
        } catch (error) {
            console.error("Failed to fetch transfers:", error)
        }
    }

    useEffect(() => {
        infiniteState.data.offset !== 0 && branchEodRead()
        //eslint-disable-next-line
    }, [infiniteState.data.offset]);

    const handleGenerate = () => {
        if (form.data.branch_id === ''|| branchUserData.data.length === 0) {
            snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Please select a branch first.', type: 'error'});
            return;
        }
        if (isToReconcile.data) {
            toReconcileList.set([])
            if (!form.data.from) {
                snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Date required to generate data.', type: 'error'});
                return;
            }
        } else {
            reconciledList.set([])
            if (!form.data.from || !form.data.to) {
                snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Date range required to generate data.', type: 'error'});
                return;
            }
            if (form.data.from > form.data.to) {
                snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Invalid Date range.', type: 'error'});
                return;
            }
        }
        branchEodRead();
        //eslint-disable-next-line
    };

    useEffect(() => {
        role !== "Regular User" ? isToReconcile.set(false) : isToReconcile.set(true) 
        handleGenerate()
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Box p={3}>
                <Box><Generate handleGenerate={handleGenerate} /></Box>
                {loader.data.isShowData && 
                    <Box mt={2}>
                        <Grid container spacing={2}>
                            <Body/>
                            <Box height="70px" />
                        </Grid>
                    </Box>
                }
                {reconciledList.data.length === 0 && <NoDataFound/>}
                <BackDrop open={navSession.data.isShow} text={"Fetching Data..."}/>
                <MessageModal open={loader.data.isShowWarningModal} close={()=>loader.set({...loader.data, isShowWarningModal:false })} text={loader.data.warningText} subtext={loader.data.warningSubText}/>
            </Box>
            <MessageModal open={loader.data.isShowWarningModal} close={()=>loader.set({...loader.data, isShowWarningModal:false })} text={loader.data.warningText} subtext={loader.data.warningSubText} trigger={true}/>
        </>
    )
}